import { Text } from "dripsy";
import * as React from "react";

export default function Paragraph({ children, notTooLarge }: { children: any; notTooLarge?: boolean }) {
  return (
    <Text
      sx={{
        fontSize: [16, 17, notTooLarge ? 17 : 17],
        letterSpacing: 0.1,
        lineHeight: [24, 26, notTooLarge ? 26 : 26],
        opacity: 0.8,
        marginBottom: "$2",
      }}
    >
      {children}
    </Text>
  );
}
